import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]

import type { PropType } from 'vue'

type AvatarSize = undefined | 'small' | 'medium' | 'large' | 'big' | 'xl'
type AvatarColor =
  | undefined
  | 'primary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger'
  | 'h-purple'
  | 'h-orange'
  | 'h-blue'
  | 'h-green'
  | 'h-red'
  | 'h-yellow'
type AvatarDotColor =
  | undefined
  | 'primary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger'


export default /*@__PURE__*/_defineComponent({
  __name: 'VAvatar',
  props: {
  picture: {
    type: String,
    default: undefined,
  },
  pictureDark: {
    type: String,
    default: undefined,
  },
  placeholder: {
    type: String,
    default: 'https://via.placeholder.com/50x50',
  },
  badge: {
    type: String,
    default: undefined,
  },
  initials: {
    type: String,
    default: '?',
  },
  size: {
    type: String as PropType<AvatarSize>,
    default: undefined,
    validator: (value: AvatarSize) => {
      // The value must match one of these strings
      if (
        [undefined, 'small', 'medium', 'large', 'big', 'xl'].indexOf(value) ===
        -1
      ) {
        console.warn(
          `VAvatar: invalid "${value}" size. Should be small, medium, large, big, xl or undefined`
        )
        return false
      }

      return true
    },
  },
  color: {
    type: String as PropType<AvatarColor>,
    default: undefined,
    validator: (value: AvatarColor) => {
      // The value must match one of these strings
      if (
        [
          undefined,
          'primary',
          'success',
          'info',
          'warning',
          'danger',
          'h-purple',
          'h-orange',
          'h-blue',
          'h-green',
          'h-red',
          'h-yellow',
        ].indexOf(value) === -1
      ) {
        console.warn(
          `VAvatar: invalid "${value}" color. Should be primary, success, info, warning, ` +
            `danger, h-purple, h-orange, h-blue, h-green, h-red, h-yellow or undefined`
        )
        return false
      }

      return true
    },
  },
  dotColor: {
    type: String as PropType<AvatarDotColor>,
    default: undefined,
    validator: (value: AvatarDotColor) => {
      // The value must match one of these strings
      if (
        [undefined, 'primary', 'info', 'warning', 'danger', 'grey'].indexOf(
          value
        ) === -1
      ) {
        console.warn(
          `VAvatar: invalid "${value}" dotColor. Should be primary, info, warning, danger, grey or undefined`
        )
        return false
      }

      return true
    },
  },
  squared: {
    type: Boolean,
    default: false,
  },
  dot: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["VAvatar", [
      __props.size && `is-${__props.size}`,
      __props.dot && 'has-dot',
      __props.dotColor && `dot-${__props.dotColor}`,
      __props.squared && __props.dot && 'has-dot-squared',
    ]])
  }, [
    _renderSlot(_ctx.$slots, "avatar", {}, () => [
      (__props.picture)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: _normalizeClass(["avatar", [__props.squared && 'is-squared']]),
            src: __props.picture,
            alt: "",
            onErrorOnce: _cache[0] || (_cache[0] = ($event: any) => ($event.target.src = 'https://via.placeholder.com/150x150'))
          }, null, 42, _hoisted_1))
        : (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: _normalizeClass(["avatar is-fake", [__props.squared && 'is-squared', __props.color && `is-${__props.color}`]])
          }, [
            _createElementVNode("span", null, _toDisplayString(__props.initials), 1)
          ], 2)),
      (__props.picture && __props.pictureDark)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            class: _normalizeClass(["avatar dark-image", [__props.squared && 'is-squared']]),
            src: __props.pictureDark,
            alt: "",
            onErrorOnce: _cache[1] || (_cache[1] = ($event: any) => ($event.target.src = 'https://via.placeholder.com/150x150'))
          }, null, 42, _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "badge", {}, () => [
      (__props.badge)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "badge",
            src: __props.badge,
            alt: "",
            onErrorOnce: _cache[2] || (_cache[2] = ($event: any) => ($event.target.src = 'https://via.placeholder.com/150x150'))
          }, null, 40, _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})